<div class="d-flex justify-content-between dialog-title">
  <div>
    <p class="mb-0 mt-1 dialog-title">Filter Ongoing Order</p>
  </div>
  <div>
    <button [mat-dialog-close]="true" mat-icon-button>
      <mat-icon class="dialog-icon">close</mat-icon>
    </button>
  </div>
</div>
<hr />

<div mat-dialog-content class="mb-2">
  <div class="w-100 pb-3">
    <input #searchLive nz-input placeholder="Order ID" style="width: 100%" [(ngModel)]="searchValue"
      (input)="liveSearch()">
  </div>
  <div class="w-100 pb-3">
    <nz-select [(ngModel)]="selectedOrderType" nzAllowClear nzPlaceHolder="Order Type"
      (ngModelChange)="onSelectOrderType(selectedOrderType)" class="d-flex w-100 flex-column">
      @for (data of orderTypeKeyValue; track data) {
        <nz-option [nzValue]="data.key"
        [nzLabel]="data.value"></nz-option>
      }
    </nz-select>
  </div>
  <div class="w-100 pb-3">
    <nz-select nzMode="multiple" nzAllowClear nzPlaceHolder="Table" [(ngModel)]="selectedTableName"
      (ngModelChange)="onTableName(selectedTableName)" class="w-100">
      @for (data of tableNameKeyValue; track data) {
        <nz-option [nzValue]="data.key"
        [nzLabel]="data.value"></nz-option>
      }
    </nz-select>
  </div>
  <div class="w-100 pb-3">
    <nz-select nzMode="multiple" nzAllowClear nzPlaceHolder="Section" [(ngModel)]="selectedSectionName"
      (ngModelChange)="onSectionName(selectedSectionName)" class="w-100">
      @for (data of sectionNameKeyValue; track data) {
        <nz-option [nzValue]="data.key"
        [nzLabel]="data.value"></nz-option>
      }
    </nz-select>
  </div>
  <div class="w-100 pb-3">
    <nz-select [(ngModel)]="selectedUser" nzAllowClear nzPlaceHolder="Created User"
      (ngModelChange)="onSelectUser(selectedUser)" class="d-flex w-100 flex-column">
      @for (data of userNameKeyValue; track data) {
        <nz-option [nzValue]="data.key"
        [nzLabel]="data.value"></nz-option>
      }
    </nz-select>
  </div>
  <div class="w-20">
    <nz-select [(ngModel)]="selectedOrderStatus" nzAllowClear nzPlaceHolder="Order Status"
      (ngModelChange)="onSelectStatus(selectedOrderStatus)" class="d-flex w-100 flex-column">
      @for (data of orderStatusKeyValue; track data) {
        <nz-option [nzValue]="data.key"
        [nzLabel]="data.value"></nz-option>
      }
    </nz-select>
  </div>
</div>
<div class="d-flex justify-content-end mb-4 me-4 mt-3">
  <button class="small-btn-width btn-radius me-2" nzType="primary" nzGhost nz-button mat-dialog-close="true">
    Close
  </button>
  <button nz-button nzType="primary" class="small-btn-width btn-radius" (click)="onSubmit()">
    Filter
  </button>
</div>
